<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Users</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Users
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="users-view">
                <!-- users view media object start -->
                <div class="row">
                    <div class="col-12 col-sm-7">
                        <div class="media mb-2">
                            <a class="mr-1" href="#">
                                <img :src="userData.profile_photo_url ?? 'https://ui-avatars.com/api/?name=' + userData.first_name + '+' + userData.last_name"
                                     alt="users view avatar" class="users-avatar-shadow rounded-circle" height="64"
                                     width="64">
                            </a>
                            <div class="media-body pt-25">
                                <h4 class="media-heading">
                                    <span class="users-view-name">
                                        {{ userData.first_name + " " + userData.last_name }}
                                    </span>
                                </h4>
                                <span>ID:</span>
                                <span class="users-view-id">{{ userData.id }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- users view media object ends -->

                <!-- users view card details start -->
                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <h5 class="mb-1"><i class="feather icon-info"></i> Personal Info</h5>
                            <div class="col-6">
                                <table class="table table-borderless">
                                    <tbody>
                                        <tr>
                                            <td>Full Name:</td>
                                            <td class="users-view-username">
                                                {{ userData.first_name + ' ' + userData.last_name}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Email:</td>
                                            <td class="users-view-name">{{ userData.email }}</td>
                                        </tr>
                                        <tr>
                                            <td>Phone</td>
                                            <td class="users-view-email">{{ userData.phone }}</td>
                                        </tr>
                                        <tr>
                                            <td>Registered at:</td>
                                            <td>{{ formatDateTime(userData.created_at) }}</td>
                                        </tr>
                                        <tr>
                                            <td>User Type:</td>
                                            <td class="users-view-role">User</td>
                                        </tr>
                                        <tr>
                                            <td>Total Rides:</td>
                                            <td class="users-view-role">{{ userData.trips_count }}</td>
                                        </tr>
                                        <tr>
                                            <td>Wallet Balance:</td>
                                            <td class="users-view-role">{{ userData.wallet?.balance ?? 0.00 }}</td>
                                        </tr>
                                        <tr>
                                            <td>Rating:</td>
                                            <td class="users-view-role">
                                                {{ starRating(userData.ratings_avg_rating ?? 0) + ` (${userData.ratings_count})` }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Status:</td>
                                            <td>
                                                <span :class="'users-view-status badge ' + statusClass(userData.email_verified_at)">{{ userData.email_verified_at ? "Active" : "Inactive" }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- users view card details ends -->

                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <div class="col-12">
                                <h5 class="mb-3 font-weight-bold">Last 5 Trips</h5>
                                <div class="table-responsive">
                                    <table class="table mb-0">
                                        <thead>
                                        <tr>
                                            <th>Ride Id</th>
                                            <th>Pickup Address</th>
                                            <th>Drop Address</th>
                                            <th>Date</th>
                                            <th>Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="trip in userData.trips" class="mb-2 p-3">
                                            <th><a :href="route('admin.trips.show', trip.id)">{{ trip.id }}</a></th>
                                            <th>{{ truncateText(trip.pickup_address) }}</th>
                                            <th>{{ truncateText(trip.drop_address) }}</th>
                                            <th>{{ formatDateTime(trip.start_time) }}</th>
                                            <th>
                                                    <span :class="'badge-glow badge badge-' + tripStatus(trip.status)">
                                                        {{ trip.status }}
                                                    </span>
                                            </th>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <div class="col-12">
                                <h5 class="mb-3 font-weight-bold">Last 5 Transactions</h5>
                                <div class="table-responsive">
                                    <table class="table mb-0">
                                        <thead>
                                        <tr>
                                            <th>Transaction Id</th>
                                            <th>Transaction Type</th>
                                            <th>Amount</th>
                                            <th>Date</th>
                                            <th>Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="transaction in userData.transactions" class="mb-2 p-3">
                                            <th>
                                                <a :href="route('admin.transactions.show', transaction.id)">
                                                    {{ transaction.id }}
                                                </a>
                                            </th>
                                            <th>
                                                <span :class="'badge ' + statusClass(transaction.type === 'credit')">
                                                    {{ transaction.type }}
                                                </span>
                                            </th>
                                            <th>{{ transaction.amount }}</th>
                                            <th>{{ formatDateTime(transaction.created_at) }}</th>
                                            <th>
                                                <span :class="'badge-glow badge badge-' + transactionStatus(transaction.readable_status)">
                                                    {{ transaction.readable_status }}
                                                </span>
                                            </th>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <div class="col-12">
                                <h5 class="mb-3 font-weight-bold">Last 2 Reviews</h5>
                                <div class="table-responsive">
                                    <table class="table mb-0">
                                        <thead>
                                        <tr>
                                            <th>Review Id</th>
                                            <th>Trip Id</th>
                                            <th>Review</th>
                                            <th>Rating</th>
                                            <th>Date</th>
                                            <th>Reviewer</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="rating in userData.ratings" class="mb-2 p-3">
                                            <th>{{ rating.id }}</th>
                                            <th>
                                                <a :href="route('admin.trips.show', `${rating.trip_id}`)">
                                                    {{ rating.trip_id }}
                                                </a>
                                            </th>
                                            <th>{{ rating.review}}</th>
                                            <th>{{ starRating(rating.rating) }}</th>
                                            <th>{{ formatDateTime(rating.created_at) }}</th>
                                            <th>
                                                <a :href="route('admin.users.show', `${rating.creatable_id}`)">
                                                    {{ `${rating.creatable?.first_name} ${rating.creatable?.last_name}` }}
                                                </a>
                                            </th>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    metaInfo: {title: 'User Admin'},
    name: 'UserShow',
    props: ['userData'],
    layout: Layout,
    data() {},
    methods: {
        formatDateTime(value) {
            if (! value) return value

            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        statusClass(value) {
            return value ? "badge-success" : "badge-warning";
        },
        tripStatus(value) {
            if (value === 'pending') {
                return "warning";
            } else if (value === 'accepted' || value === 'in_progress' || value === 'picked_up' || value === 'in_transit')
            {
                return "success";
            } else if (value === 'completed')
            {
                return "primary";
            } else {
                return "danger";
            }
        },
        transactionStatus(value) {
            if (value === 'pending') {
                return "warning";
            } else if (value === 'success')
            {
                return "success";
            } else {
                return "danger";
            }
        },
        starRating(rating) {
            if (rating === 0) {
                return '⭐️'.repeat(5);
            }
            return '⭐️'.repeat(Math.round(rating));
        },
        truncateText(text, length = 30) {
            return text?.length > length ? text.slice(0, length) + '...' : text;
        }
    },
    mounted() {},
}
</script>
